import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["checked", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { twMerge } from 'tailwind-merge';
import Checkbox from './ui-components/Checkbox';
import CodeBlockWithCopy from './CodeBlockWithCopy';
import { processShortEmojiMessage, isShortEmojiMessage } from 'flow/utils/message-utils';
import { processMarkdownWithMentions } from 'flow/utils/markdown-with-mentions';
import useFeatureFlags, { FeatureFlags } from 'flow/hooks/useFeatureFlags';
import { jsx as _jsx } from "react/jsx-runtime";
// Component definitions moved outside to avoid recreation on each render
var CodeComponent = function CodeComponent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var codeString = String(children).replace(/\n$/, '');
  return /*#__PURE__*/_jsx(CodeBlockWithCopy, {
    code: codeString,
    inline: !!props.inline
  });
};
var RICKROLL_URL = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';
var getLinkComponent = function getLinkComponent(videoDark) {
  return function (_ref2) {
    var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props), {}, {
      target: "_blank",
      rel: "noopener noreferrer",
      className: videoDark ? '!text-blue-300' : undefined,
      children: children
    }));
  };
};
var RickrollLinkComponent = function RickrollLinkComponent(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props), {}, {
    href: RICKROLL_URL,
    target: "_blank",
    rel: "noopener noreferrer",
    children: children
  }));
};
var getParagraphComponent = function getParagraphComponent(videoDark) {
  return function (_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/_jsx("p", {
      className: twMerge('leading-6 whitespace-pre-wrap', videoDark ? 'text-gray-300' : 'text-black'),
      children: children
    });
  };
};
var InputComponent = function InputComponent(_ref5) {
  var checked = _ref5.checked,
    type = _ref5.type,
    props = _objectWithoutProperties(_ref5, _excluded4);
  if (type === 'checkbox') {
    return /*#__PURE__*/_jsx(Checkbox, {
      checked: !!checked,
      disabled: true,
      onChange: function onChange() {},
      className: "inline-block align-middle"
    });
  }
  return /*#__PURE__*/_jsx("input", _objectSpread({
    type: type,
    checked: checked
  }, props));
};
var getMarkdownComponents = function getMarkdownComponents(videoDark) {
  return {
    code: CodeComponent,
    a: getLinkComponent(videoDark),
    p: getParagraphComponent(videoDark),
    input: InputComponent
  };
};
var StyledMessageBody = function StyledMessageBody(_ref6) {
  var message = _ref6.message,
    sessionKey = _ref6.sessionKey,
    _ref6$videoDark = _ref6.videoDark,
    videoDark = _ref6$videoDark === void 0 ? false : _ref6$videoDark;
  var msg = message.get('message');
  var stylings = message.get('stylings');
  var _useFeatureFlags = useFeatureFlags(),
    hasFeature = _useFeatureFlags.hasFeature;
  var hasMarkdownEnabled = hasFeature(FeatureFlags.MARKDOWN) || false;
  var hasEasterEggs = hasFeature(FeatureFlags.EASTER_EGGS) || false;
  var markdownComponents = getMarkdownComponents(videoDark);
  var components = hasEasterEggs ? _objectSpread(_objectSpread({}, markdownComponents), {}, {
    a: RickrollLinkComponent
  }) : markdownComponents;
  if (!msg) return '';

  // Check if this is a short emoji message for special handling
  var isShortEmoji = isShortEmojiMessage(msg);

  // Process markdown with mentions only if feature is enabled
  var processedContent = processMarkdownWithMentions(msg, stylings ? stylings.toArray() : [], sessionKey, components, hasMarkdownEnabled);

  // Apply emoji processing if needed BEFORE wrapping in div
  var finalContent = isShortEmoji ? processShortEmojiMessage(message === null || message === void 0 ? void 0 : message.get('message'), message === null || message === void 0 ? void 0 : message.get('key'), processedContent) : processedContent;
  return /*#__PURE__*/_jsx("div", {
    className: "markdown max-w-none whitespace-break-spaces",
    children: finalContent
  });
};
export default StyledMessageBody;